import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';

import { useTranslation } from 'react-i18next';

import * as columnsDefinition from '../utils/columnsDefinition';
import { useSidepanel } from '../../../../../shared/contexts/Sidepanel.provider';
import type { BidResponse } from '../../../../../shared/entities/BidResponse';
import { useGetBidResponsesQuery } from '../hooks/bidResponse.hook';
import { useGetVaultPropertiesQuery } from '../hooks/vaultProperty.hook';
import { getBidResponseTableConfig } from '../utils/tableConfig';
import { BidResponseSidePanel } from './bidResponseSidePanel/BidResponseSidePanel';

export function BidResponseTab() {
  const { t } = useTranslation('bidResponse');
  const { data: vaultProperties } = useGetVaultPropertiesQuery();
  const { data: bidResponsesData } = useGetBidResponsesQuery();

  const customColumns = vaultProperties.map(property =>
    columnsDefinition.customProperty(property),
  );

  const columns = [
    columnsDefinition.bidResponseTitle(t),
    columnsDefinition.responseDeadline(t),
    columnsDefinition.owner(t),
    ...customColumns,
    columnsDefinition.action,
  ];

  const { togglePanel, closePanel } = useSidepanel();

  const onRowClick = (bidResponse: BidResponse) => {
    togglePanel({
      noBackdrop: true,
      content: (
        <BidResponseSidePanel
          bidResponseId={bidResponse.id}
          closePanel={closePanel}
        />
      ),
    });
  };

  const tableConfig = getBidResponseTableConfig(t, { onRowClick });

  const table = useMantineReactTable({
    columns,
    data: bidResponsesData.bidResponses,
    ...tableConfig,
  });

  return <MantineReactTable table={table} />;
}
